import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { wrapEventListener } from './helpers/wrap-event-listener';
export var EventTarget =
/*#__PURE__*/
function () {
  function EventTarget(_nativeEventTarget) {
    _classCallCheck(this, EventTarget);

    this._nativeEventTarget = _nativeEventTarget;
    this._listeners = new WeakMap();
  }

  _createClass(EventTarget, [{
    key: "addEventListener",
    value: function addEventListener(type, listener, // @todo EventListenerOrEventListenerObject | null = null,
    options) {
      var wrappedEventListener = this._listeners.get(listener);

      if (wrappedEventListener === undefined) {
        wrappedEventListener = wrapEventListener(this, listener);

        if (typeof listener === 'function') {
          this._listeners.set(listener, wrappedEventListener);
        }
      }

      return this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      return this._nativeEventTarget.dispatchEvent(event);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener, // @todo EventListenerOrEventListenerObject | null = null,
    options) {
      var wrappedEventListener = this._listeners.get(listener);

      return this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
    }
  }]);

  return EventTarget;
}();